import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import {
  StepBackwardOutlined, CaretLeftOutlined,
  CaretRightOutlined, StepForwardOutlined,
  PlusOutlined, EditOutlined, DeleteOutlined,
  SaveOutlined, CloseOutlined, SearchOutlined,
} from '@ant-design/icons';
import { useDepartmentMajorForm } from './hooks/useDepartmentMajorForm';
import './P910QForm.css';

const { TextArea } = Input;

const P910QForm: React.FC = () => {
  const {
    mode, loading, f90q_01, f90q_11, f90q_91, f90q_92, f90q_93,
    setF90q01, setF90q11,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete,
    quickSearch, recordPosition, recordCount,
  } = useDepartmentMajorForm();

  const [searchKey, setSearchKey] = useState('');

  const isEditing = mode === 'add' || mode === 'edit';

  return (
    <Spin spinning={loading}>
      <div className="p910q-form">
        <h2>科系定義檔</h2>

        {/* Quick Search */}
        <div className="p910q-search-bar">
          <Input
            placeholder="輸入科系名稱快速搜尋"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            onPressEnter={() => quickSearch(searchKey)}
            style={{ width: 200 }}
            disabled={isEditing}
          />
          <Button
            icon={<SearchOutlined />}
            onClick={() => quickSearch(searchKey)}
            disabled={isEditing}
          >
            搜尋
          </Button>
          <span className="p910q-record-info">
            {recordPosition} / {recordCount}
          </span>
        </div>

        {/* Navigation */}
        <div className="p910q-nav-bar">
          <Button icon={<StepBackwardOutlined />} onClick={navFirst} disabled={isEditing}>首筆</Button>
          <Button icon={<CaretLeftOutlined />} onClick={navPrev} disabled={isEditing}>前筆</Button>
          <Button icon={<CaretRightOutlined />} onClick={navNext} disabled={isEditing}>次筆</Button>
          <Button icon={<StepForwardOutlined />} onClick={navLast} disabled={isEditing}>末筆</Button>
        </div>

        {/* Form Fields */}
        <div className="p910q-fields">
          <div className="p910q-field-row">
            <label>科系名稱</label>
            <Input
              value={f90q_01}
              onChange={(e) => setF90q01(e.target.value)}
              maxLength={30}
              disabled={mode !== 'add'}
              style={{ width: 240 }}
            />
          </div>
          <div className="p910q-field-row">
            <label>備註</label>
            <TextArea
              value={f90q_11}
              onChange={(e) => setF90q11(e.target.value)}
              disabled={!isEditing}
              rows={4}
              style={{ width: 360 }}
            />
          </div>

          {/* Audit fields (read-only) */}
          <div className="p910q-field-row">
            <label>建立人員</label>
            <Input value={f90q_91} disabled style={{ width: 120 }} />
          </div>
          <div className="p910q-field-row">
            <label>建立日期</label>
            <Input value={f90q_92 ? f90q_92.substring(0, 10) : ''} disabled style={{ width: 140 }} />
          </div>
          <div className="p910q-field-row">
            <label>異動人員</label>
            <Input value={f90q_93} disabled style={{ width: 120 }} />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="p910q-actions">
          {!isEditing ? (
            <>
              <Button type="primary" icon={<PlusOutlined />} onClick={startAdd}>新增</Button>
              <Button icon={<EditOutlined />} onClick={startEdit} disabled={recordCount === 0}>修改</Button>
              <Button
                danger
                icon={<DeleteOutlined />}
                disabled={recordCount === 0}
                onClick={() => {
                  Modal.confirm({
                    title: '確認刪除',
                    content: `確定要刪除科系「${f90q_01}」嗎？`,
                    onOk: doDelete,
                  });
                }}
              >
                刪除
              </Button>
            </>
          ) : (
            <>
              <Button type="primary" icon={<SaveOutlined />} onClick={save}>存檔</Button>
              <Button icon={<CloseOutlined />} onClick={cancel}>還原</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P910QForm;
